
export default {
  props: {
    label: { type: String, required: true },
    recentData: { type: String, required: true },
    seasonData: { type: String, required: true },
    allTimeData: { type: String, required: true },
  },
};
